export default "__VITE_ASSET__NY$B_nek__$_?component__"